import "css/shippingResponsive.css";
import React, {  useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT, LIMIT_PAGE  } from "constants/variables";
import Box from '@mui/material/Box'; 
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';  
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import PropTypes from 'prop-types';
import TableSortingShippingVehicles from 'pages/shipping/editOrNewShipping/SortingTablesShippingVehicles'; 

const initialFiltersVehicles= {
  "idFrom":"",
  "idTo":"",
  "documentIdFrom":"",
  "documentIdTo":"",
  "tradenameFrom":"",
  "tradenameTo":"",
  "vehicleStoreFrom":"",
  "vehicleStoreTo":""
};
 
const initialStateVehicles = [{
  "id":"",
  "licenseplate":0,
  "defaultvehicle":false,
  "documentid":"",
  "defaultdriver":"",
  "enabled":true,
  "store_id":0,
  "store_documnettype_id":0,
  "store_tradename":""
 
}];
  
const ShippingSearchVehicles = ({ showModalSearchVehicles, setShowModalSearchVehicles,setFormShipping,formShipping}) => {
  const {t,i18n} = useTranslation(['listDataShipping']);
  const state = useSelector((state) => state);
  const {token} = state.loginUser
  const [dataVehicle, setDataVehicle] = useState(initialStateVehicles);
  const [isLoadingErrorVehicle, setIsLoadingErrorVehicle] = useState(false);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [inputTextVehicle, setInputTextVehicle] = useState("");
  const [applyFiltersVehicle, setApplyFiltersVehicle]= useState(initialFiltersVehicles);
  const [filtersVehicle, setFiltersVehicle]= useState(initialFiltersVehicles);
  const [openEditFilterVehicle,setOpenEditFilterVehicle]= useState(false);
  const [errorsFiltersVehicle, setErrorsFiltersVehicle] = useState({});
  const [numTotRegFilter,setNumTotRegFilter]= useState(0);
  const [numTotRegVehicle,setNumTotRegVehicle]= useState(0);
  const [activeOffsetVehicle, setActiveOffsetVehicle]= useState(false);
  const [currencyOffsetVehicle, setCurrencyOffsetVehicle] = useState(0);
  const [rangeOffsetVehicle, setRangeOffsetVehicle] = useState([{}]); 
  const dispatch = useDispatch(); 
   
  const keyPress = useCallback(
    (e) => {
      if (e.key === 'Escape' && setShowModalSearchVehicles) {
        setDataVehicle(initialStateVehicles);
        setIsLoadingErrorVehicle(false);
        dispatch(setLoading(false))
        setInputTextVehicle("");
        setApplyFiltersVehicle(initialFiltersVehicles);
        setFiltersVehicle(initialFiltersVehicles);
        setOpenEditFilterVehicle(false);
        setErrorsFiltersVehicle({});
        setNumTotRegFilter(0);
        setNumTotRegVehicle(0);
        setActiveOffsetVehicle(false);
        setCurrencyOffsetVehicle(0);
        setRangeOffsetVehicle([{}]);
        setShowModalSearchVehicles(false);
      }
    },
    [ setDataVehicle,
      setIsLoadingErrorVehicle, 
      setInputTextVehicle,
      setApplyFiltersVehicle,
      setFiltersVehicle,
      setOpenEditFilterVehicle,
      setErrorsFiltersVehicle,
      setNumTotRegFilter,
      setNumTotRegVehicle,
      setActiveOffsetVehicle,
      setCurrencyOffsetVehicle,
      setRangeOffsetVehicle,
      dispatch,
      setShowModalSearchVehicles
    ]
  );

  const handleCloseDataEditVehicle = () => {
    setDataVehicle(initialStateVehicles);
    setIsLoadingErrorVehicle(false);
    dispatch(setLoading(false))
    setInputTextVehicle("");
    setApplyFiltersVehicle(initialFiltersVehicles);
    setFiltersVehicle(initialFiltersVehicles);
    setOpenEditFilterVehicle(false);
    setErrorsFiltersVehicle({});
    setNumTotRegFilter(0);
    setNumTotRegVehicle(0);
    setActiveOffsetVehicle(false);
    setCurrencyOffsetVehicle(0);
    setRangeOffsetVehicle([{}]); 
    setShowModalSearchVehicles(false)
	};

  const toggleDrawerSearchFormVehicles  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseDataEditVehicle();
    }
  };

  let inputHandlerVehicle = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputTextVehicle(lowerCase);
  };

  const openEditFiltersVehicle = () => {
    setFiltersVehicle(applyFiltersVehicle);
    setOpenEditFilterVehicle(!openEditFilterVehicle);
  };

  const toggleDrawerFilterEditVehicle = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      handleCloseDataEditVehicle();
    }
  };

  const handleCancelFiltersVehicle = () => {
    setErrorsFiltersVehicle({});
    setFiltersVehicle(initialFiltersVehicles);
    setOpenEditFilterVehicle(!openEditFilterVehicle);
  };

  const handleChangeFilterEditVehicle = (e) => {
    const { name, value } = e.target;
    setFiltersVehicle(filtersVehicle => ({
      ...filtersVehicle,
      [name]: value
    }));
  };

  const handleBlurFilterEditVehicle = (e) => {
    setErrorsFiltersVehicle(validateFormFilterVehicle());
    handleChangeFilterEditVehicle(e);
  };

  const handleSubmitFilterEditVehicle = () => {
    setErrorsFiltersVehicle(validateFormFilterVehicle());
    if (Object.keys(errorsFiltersVehicle).length === 0) {
      setApplyFiltersVehicle(filtersVehicle);
      setFiltersVehicle(initialFiltersVehicles);
      setErrorsFiltersVehicle({});
      setOpenEditFilterVehicle(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }
  const handleDeleteFiltersVehicle = () => {
    setErrorsFiltersVehicle({});
    setFiltersVehicle(initialFiltersVehicles);
    setApplyFiltersVehicle(initialFiltersVehicles);
    setOpenEditFilterVehicle(!openEditFilterVehicle);
  };

  const validateFormFilterVehicle = () => {

    let errorsFiltersVehicle = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    
    if (filtersVehicle.idFrom!=="" & !regexNumber.test(filtersVehicle.idFrom)) {
      errorsFiltersVehicle.idFrom = 'Text_TextNoNumber';
    }
    if (filtersVehicle.idTo!=="" & !regexNumber.test(filtersVehicle.idTo)) {
      errorsFiltersVehicle.idTo = 'Text_TextNoNumber';
    }
    if (filtersVehicle.idFrom!=="" & !errorsFiltersVehicle.idFrom!==undefined){
      if (filtersVehicle.idTo!=="" & !errorsFiltersVehicle.idTo!==undefined){
        if (parseInt(filtersVehicle.idTo)<parseInt(filtersVehicle.idFrom)){
          errorsFiltersVehicle.idTo = 'Text_TextGreater_Id';
        }
      }
    }

    if (regexInvalidCharacters.test(filtersVehicle.documentIdFrom)) {
      errorsFiltersVehicle.documentIdFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersVehicle.documentIdTo)) {
      errorsFiltersVehicle.documentIdTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersVehicle.tradenameFrom)) {
      errorsFiltersVehicle.tradenameFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersVehicle.tradenameTo)) {
      errorsFiltersVehicle.tradenameTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersVehicle.vehicleStoreFrom)) {
      errorsFiltersVehicle.vehicleStoreFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersVehicle.vehicleStoreTo)) {
      errorsFiltersVehicle.vehicleStoreTo = 'Text_TextNoValid';
    } 
     
    if (filtersVehicle.documentIdTo!=="" & filtersVehicle.documentIdTo<filtersVehicle.documentIdFrom){
      errorsFiltersVehicle.documentIdTo = 'Text_TextGreater_documentid';
    }
    if (filtersVehicle.tradenameTo!=="" & filtersVehicle.tradenameTo<filtersVehicle.tradenameFrom){
      errorsFiltersVehicle.tradenameTo = 'Text_TextGreater_tradename';
    }
    
    if (filtersVehicle.vehicleStoreTo!=="" & filtersVehicle.vehicleStoreTo<filtersVehicle.vehicleStoreFrom){
      errorsFiltersVehicle.vehicleStoreTo = 'Text_TextGreater_vehicles';
    }
    return errorsFiltersVehicle;
  }  

  const filteredDataVehicle = dataVehicle.filter((el) => {
    if (inputTextVehicle === '') {
        return el;
    }
    else {
      let dataTranslate = 
        String(el.id || '') +
        String(el.licenseplate || '')+
        String(el.defaultdriver || '')+
        String(el.store_documentid || '')+
        String(el.store_tradename || '') ;
      let result = dataTranslate.toLowerCase().includes(inputTextVehicle.toLowerCase());
      return result;  
    }
  })
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);
  
   
  useEffect(() => {
    let isMounted = true;

    const fetchnumTotRegVehicle = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `shipping/getinformationtablevehicles`, token);
        if (getData.err) {
          setDataVehicle(initialStateVehicles);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegVehicle(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };
 
    const fetchnumTotRegFilter = async () => {
      try {
        const getData = (formShipping.rel_trans_documentid!==undefined && formShipping.rel_trans_documentid!==null && formShipping.rel_trans_documentid!=="")
        ?await helpHttp().post2(ENDPOINT,`shipping/getcountfiltervehiclesstore`,token,formShipping.rel_trans_documentid,applyFiltersVehicle)
        :await await helpHttp().post(ENDPOINT,`shipping/getcountfiltervehicles`,token,applyFiltersVehicle);
        if (getData.err || getData.message === "Load failed") {
          setDataVehicle(initialStateVehicles);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegFilter(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };

    const fetchDataVehicle = async () => {
      dispatch(setLoading(true));
      try {
        const getData = (formShipping.rel_trans_documentid!==undefined && formShipping.rel_trans_documentid!==null && formShipping.rel_trans_documentid!=="")
        ?await helpHttp().get4(ENDPOINT,`shipping/getvehiclesstore`,token,formShipping.rel_trans_documentid,currencyOffsetVehicle,LIMIT_PAGE,applyFiltersVehicle)
        :await helpHttp().get3(ENDPOINT,`shipping/getvehicles`,token,currencyOffsetVehicle,LIMIT_PAGE,applyFiltersVehicle);
        if (getData.err || getData.message === "Load failed") {
          setDataVehicle(initialStateVehicles);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataVehicle(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };
    
    if (showModalSearchVehicles){
      fetchnumTotRegVehicle();
      fetchnumTotRegFilter();
      fetchDataVehicle();
    }
    return () => { isMounted = false };
  }, [t,i18n,token,dispatch,applyFiltersVehicle,currencyOffsetVehicle,showModalSearchVehicles,formShipping.rel_trans_documentid]);

  return(
    <>
      {showModalSearchVehicles && 
        <div>
          <SwipeableDrawer PaperProps={{ className: "shipping-search-panel shipping-lookup-panel" }}
            anchor='right'
            open={true}
            onClose={toggleDrawerSearchFormVehicles(false)}
            onOpen={toggleDrawerSearchFormVehicles(true)}>
            <Container maxWidth={false}>
              <Box sx={{ bgcolor: '#ffffff', width: '100%', maxWidth: '100%'}}>
                 <div className="formdi-pending-header2"> 
                  <h1 className="formdi-pending-title">
                    {isLoadingErrorVehicle?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoadingData?<CircularProgress color={"primary"}/>:<i className="fas fa-address-card text-warning"></i>} {t('Text_TICKETS_Vehicles_Search')}
                  </h1>
                  
                  <div>
                      <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={handleCloseDataEditVehicle} >{t('Button_Back')}</button><> </>
                  </div> 
                </div>  
                <br/>
                <div className="formdi-pending-search"> 
                  <TextField
                    autoComplete="off"
                    id="outlined-basic"
                    variant="outlined"
                    value={inputTextVehicle}
                    inputProps={{ style: {fontSize: '18px'} }}
                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                    placeholder={(formShipping.rel_trans_documentid===undefined || formShipping.rel_trans_documentid===null || formShipping.rel_trans_documentid==="")?t('Text_Vehicle_Search'):t('Text_Vehicle_Store_Search')} 
                    onChange={inputHandlerVehicle}
                    fullWidth
                    label={(formShipping.rel_trans_documentid===undefined || formShipping.rel_trans_documentid===null || formShipping.rel_trans_documentid==="")?t('Text_Vehicle_Search'):t('Text_Vehicle_Store_Search')} >
                  </TextField>
                </div>
                <br/>
                <div id="myNewDIV" className="formdi-pending-filters">
                  <h1 className="formdi-pending-filter-title">{t('Text_Filter')}</h1> 
                    <div className="formdi-pending-filters-row">
                      <button type="button" className={`formdi-pending-chip ${applyFiltersVehicle.vehicleStoreFrom!=="" || applyFiltersVehicle.vehicleStoreTo!=="" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersVehicle} >
                        <span className={`formdi-pending-dot ${applyFiltersVehicle.vehicleStoreFrom!=="" || applyFiltersVehicle.vehicleStoreTo!==""? "formdi-pending-dot--on": ""}`}/>
                        {t("Text_vehicles")}
                      </button>
                      {(formShipping.rel_trans_documentid===undefined || formShipping.rel_trans_documentid===null || formShipping.rel_trans_documentid==="")&&
                        <> 
                          <button type="button" className={`formdi-pending-chip ${(applyFiltersVehicle.documentIdFrom!=="" || applyFiltersVehicle.documentIdTo!=="")? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersVehicle} >
                            <span className={`formdi-pending-dot ${(applyFiltersVehicle.documentIdFrom!=="" || applyFiltersVehicle.documentIdTo!=="")? "formdi-pending-dot--on": ""}`}/>
                            {t("Text_documentid")}
                          </button>
                          <button type="button" className={`formdi-pending-chip ${(applyFiltersVehicle.tradenameFrom!=="" || applyFiltersVehicle.tradenameTo!=="")? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersVehicle} >
                            <span className={`formdi-pending-dot ${(applyFiltersVehicle.tradenameFrom!=="" || applyFiltersVehicle.tradenameTo!=="")? "formdi-pending-dot--on": ""}`}/>
                            {t("Text_tradename")}
                          </button>
                        </>
                      }  
                  </div>
                </div>  
                <br/>
                {!isLoadingData ?
                  <>
                    <div className="formdi-pending-card-flat">
                      <div className="formdi-pending-card-content"> 
                        <TableSortingShippingVehicles
                          dataVehicle={filteredDataVehicle}
                          numTotRegFilter={ numTotRegFilter}
                          titleTable={(formShipping.rel_trans_documentid===undefined || formShipping.rel_trans_documentid===null || formShipping.rel_trans_documentid==="")?t('Text_Vehicles_Table'):formShipping.rel_trans_tradename}
                          numTotRegVehicle={numTotRegVehicle}
                          activeOffsetVehicle={activeOffsetVehicle}
                          rangeOffsetVehicle={rangeOffsetVehicle}
                          currencyOffsetVehicle={currencyOffsetVehicle}
                          setCurrencyOffsetVehicle={setCurrencyOffsetVehicle} 
                          setFormShipping={setFormShipping}
                          handleCloseDataEditVehicle={handleCloseDataEditVehicle}
                        >
                        </TableSortingShippingVehicles>
                      </div>             
                    </div>
                    {openEditFilterVehicle &&
                      <div>
                      <SwipeableDrawer PaperProps={{ className: "shipping-search-panel shipping-lookup-panel" }}
            anchor='right'
                        open={true}
                        onClose={toggleDrawerFilterEditVehicle(false)}
                        onOpen={toggleDrawerFilterEditVehicle(true)}>
                        <Container maxWidth={false}>
                          <Box sx={{ bgcolor: '#ffffff',minHeight:'100vh', width: '100%', maxWidth: '100%' }}>
                            <br/>
                              <div id="myDIV">
                                <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                              </div>
                              <hr className="sidebar-divider d-none d-md-block"/>
                              <form autoComplete="off" className="shipping-search-filters newfilterformstore" onSubmit={handleCancelFiltersVehicle}>  
                                <div className="form-floating mb-3 px-4 primary">
                                  <div className="form-group">
                                    <TextField autoComplete="off"
                                      id="vehicleStoreFrom" 
                                      name="vehicleStoreFrom"
                                      value={filtersVehicle.vehicleStoreFrom}
                                      inputProps={{ style: {width: 350,  fontSize: '18px', }, maxLength: 50 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      label={errorsFiltersVehicle.vehicleStoreFrom!=null?t(errorsFiltersVehicle.vehicleStoreFrom):t('PlaceHolder_Filter_vehicles_From')}
                                      placeholder={t('PlaceHolder_Filter_vehicles_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditVehicle}
                                      onChange={handleChangeFilterEditVehicle}/>
                                    
                                    <TextField autoComplete="off"
                                    
                                      id="vehicleStoreTo" 
                                      name="vehicleStoreTo"
                                      value={filtersVehicle.vehicleStoreTo}
                                      inputProps={{ style: {width: 350,  fontSize: '18px', }, maxLength: 50 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      label={errorsFiltersVehicle.vehicleStoreTo!=null?t(errorsFiltersVehicle.vehicleStoreTo):t('PlaceHolder_Filter_vehicles_to')}
                                      placeholder={t('PlaceHolder_Filter_vehicles_to')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditVehicle}
                                      onChange={handleChangeFilterEditVehicle}/>
                                  </div>
                                  {(formShipping.rel_trans_documentid===undefined || formShipping.rel_trans_documentid===null || formShipping.rel_trans_documentid==="")&&
                                    <>
                                      <div className="form-group">
                                        <TextField autoComplete="off"
                                          id="documentIdFrom" 
                                          name="documentIdFrom"
                                          value={filtersVehicle.documentIdFrom}
                                          inputProps={{ style: {width: 350,  fontSize: '18px', }, maxLength: 100 }}
                                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                          label={errorsFiltersVehicle.documentIdFrom!=null?t(errorsFiltersVehicle.documentIdFrom):t('Text_Filter_documentId_From')}
                                          placeholder={t('PlaceHolder_Filter_documentid_From')}
                                          variant="outlined"
                                          onBlur={handleBlurFilterEditVehicle}
                                          onChange={handleChangeFilterEditVehicle}/>
                                        
                                        <TextField autoComplete="off"
                                        
                                          id="documentIdTo" 
                                          name="documentIdTo"
                                          value={filtersVehicle.documentIdTo}
                                          inputProps={{ style: {width: 350,  fontSize: '18px', }, maxLength: 100 }}
                                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                          label={errorsFiltersVehicle.documentIdTo!=null?t(errorsFiltersVehicle.documentIdTo):t('Text_Filter_documentId_To')}
                                          placeholder={t('PlaceHolder_Filter_documentid_to')}
                                          variant="outlined"
                                          onBlur={handleBlurFilterEditVehicle}
                                          onChange={handleChangeFilterEditVehicle}/>
                                      </div>
                                      <div className="form-group">
                                        <TextField autoComplete="off"
                                          id="tradenameFrom" 
                                          name="tradenameFrom"
                                          value={filtersVehicle.tradenameFrom}
                                          inputProps={{ style: {width: 350,  fontSize: '18px', }, maxLength: 100 }}
                                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                          label={errorsFiltersVehicle.tradenameFrom!=null?t(errorsFiltersVehicle.tradenameFrom):t('Text_Filter_tradename_From')}
                                          placeholder={t('PlaceHolder_Filter_tradename_From')}
                                          variant="outlined"
                                          onBlur={handleBlurFilterEditVehicle}
                                          onChange={handleChangeFilterEditVehicle}/>
                                          
                                        <TextField autoComplete="off"
                                          
                                          id="tradenameTo" 
                                          name="tradenameTo"
                                          value={filtersVehicle.tradenameTo}
                                          inputProps={{ style: {width: 350,  fontSize: '18px', }, maxLength: 100 }}
                                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                          label={errorsFiltersVehicle.tradenameTo!=null?t(errorsFiltersVehicle.tradenameTo):t('Text_Filter_tradename_To')}
                                          placeholder={t('PlaceHolder_Filter_tradename_to')}
                                          variant="outlined"
                                          onBlur={handleBlurFilterEditVehicle}
                                          onChange={handleChangeFilterEditVehicle}/>
                                      </div> 
                                    </>
                                  }                 
                                </div>
                                <hr className="sidebar-divider d-none d-md-block"/>
                                <div className="formdi-pending-action-group">
                                  <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEditVehicle}>
                                    {t('Button_Apply')}
                                  </button> 
                                  <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeleteFiltersVehicle}>
                                    {t('Button_Cancel_Filters')}
                                  </button>
                                </div>  
                            </form>
                          </Box>
                        </Container>
                      </SwipeableDrawer>
                    </div>
                  }  
                  {/* End Content Row */}
                  </>:
                    <LoadingNews/>   
                }
                                
              </Box>
            </Container>
          </SwipeableDrawer>
        </div>
      }  
    </>
  )
}

ShippingSearchVehicles.propTypes = {
  showModalSearchVehicles: PropTypes.bool.isRequired,
  setShowModalSearchVehicles: PropTypes.func.isRequired, 
  setFormShipping: PropTypes.func.isRequired
};

export default ShippingSearchVehicles;
